'use client';

import * as React from 'react';
import createCache from '@emotion/cache';
import type { EmotionCache, Options as OptionsOfCreateCache } from '@emotion/cache';
import { CacheProvider as DefaultCacheProvider } from '@emotion/react';

export interface EmotionCacheProviderProps {
  options: Omit<OptionsOfCreateCache, 'insertionPoint'>;
  CacheProvider?: (props: { value: EmotionCache; children: React.ReactNode }) => React.JSX.Element | null;
  children: React.ReactNode;
}

// Simplified emotion cache provider for React
export default function EmotionCacheProvider(props: EmotionCacheProviderProps): React.JSX.Element {
  const { options, CacheProvider = DefaultCacheProvider, children } = props;

  const [cache] = React.useState<EmotionCache>(() => {
    const emotionCache = createCache(options);
    emotionCache.compat = true;
    return emotionCache;
  });

  return <CacheProvider value={cache}>{children}</CacheProvider>;
}
